import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { I18nService, TranslatePipe } from '@recruitee/i18n';
import type { Admin, InterviewResult } from '@recruitee/interview-results-types';
import {
  DateComponent,
  DividerComponent,
  TruncateComponent,
  BadgeComponent,
  AvatarComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-interview-member',
  templateUrl: 'interview-member.component.html',
  styleUrls: ['./interview-member.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AvatarComponent,
    BadgeComponent,
    TruncateComponent,
    DividerComponent,
    DateComponent,
    TranslatePipe,
  ],
})
export class InterviewMemberComponent {
  @Input() public result: InterviewResult;

  public name: string;
  public initials?: string;
  public photoThumbUrl: string;
  public authorExists: boolean = false;

  constructor(private i18n: I18nService) {}

  public ngOnChanges() {
    this.setData();
  }

  public setPhotoThumbUrl() {
    this.photoThumbUrl = this.result.admin
      ? this.result.admin.photoThumbUrl
      : this.result.guest!.photoThumbUrl;
  }

  public setName() {
    if (this.result.admin) {
      this.name = this.result.admin.firstName
        ? `${this.result.admin.firstName} ${this.result.admin.lastName}`
        : (<Admin>this.result.admin).name;
    } else if (this.result.guest) {
      this.name = this.result.guest.name;
    }
  }

  public setInitials() {
    this.initials = this.result.admin ? this.result.admin.initials : this.result.guest!.initials;
  }

  public setData() {
    this.checkIfAuthorExists();
    if (this.authorExists) {
      this.setInitials();
      this.setName();
      this.setPhotoThumbUrl();
    } else {
      this.setDataForDeletedUser();
    }
  }

  private checkIfAuthorExists() {
    this.authorExists = !!(
      (this.result.admin && !this.result.admin.anonymizedAt) ||
      this.result.guest
    );
  }

  private setDataForDeletedUser() {
    this.name = this.i18n.translate('app.common.deleted_user');
  }
}
